import React, { useEffect, useState } from '../../../_snowpack/pkg/react.js';
import * as Dialog from '../../../_snowpack/pkg/@crystallize/react-dialog.js';
import { Link } from '../../../_snowpack/pkg/react-router-dom.js';
import config from '../../app-config.js';
import DocumentTitle from '../../modules/document-title/index.js';
import LoadingSpinner from '../../modules/loading-spinner.js';
import { redirectForAuthenticatedSession } from '../../gates/auth-gate/index.js';
import MagicDialog from './magic-dialog.js';
import Google from './providers/google-icon.svg';
import Facebook from './providers/facebook-icon.svg';
import GitHub from './providers/github-icon.svg';
import Twitter from './providers/twitter-icon.svg';
import LinkedIn from './providers/linkedin-icon.svg';
import { Divider, Form, Headline, Inner, Label, List, ListItem, LogoLink, Title, Wrapper } from './styles.js';
const SOCIAL_LOGINS = [{
  name: 'Google',
  image: Google
}, {
  name: 'GitHub',
  image: GitHub
}, {
  name: 'Facebook',
  image: Facebook
}, {
  name: 'Twitter',
  image: Twitter
}, {
  name: 'LinkedIn',
  image: LinkedIn
}];
const labels = {
  signup: {
    title: `Let's get started`,
    magicLinkButton: 'Create a free account'
  },
  signin: {
    title: 'Login to Crystallize',
    magicLinkButton: 'Send me a magic link'
  }
};

function SignInSignUp(props) {
  const [submitting, setSubmitting] = useState(false);
  const isSignUp = props.match.path === '/signup'; // Store redirect in LS

  useEffect(() => {
    redirectForAuthenticatedSession.save();
  }, []);
  useEffect(() => {
    return () => {
      Dialog === null || Dialog === void 0 ? void 0 : Dialog.closeCurrent();
    };
  });

  const handleSubmit = async event => {
    event.preventDefault();
    setSubmitting(true);
    const email = document.querySelector('#sign-with-email').value;
    let retryToken;
    let heading;
    let subHeading;
    const magicUrl = `${config.API_URL}/auth/magic-link?email=${encodeURIComponent(email)}`;

    try {
      const response = await fetch(magicUrl);
      const data = await response.json();
      retryToken = data.retryToken;

      if (data.error === 'Forbidden' && data.statusCode === 403) {
        heading = 'Magic link already sent!';
        subHeading = 'No more links allowed for this email. Please check your spam folder or try after some time.';
      }
    } catch (error) {
      console.error(`something happen trying to get a magic link`);
    }

    function resendEmail() {
      return fetch(`${magicUrl}&retryToken=${retryToken}`);
    }

    setSubmitting(false);
    event.target.reset();
    await Dialog.showDialog({
      body: /*#__PURE__*/React.createElement(MagicDialog, {
        resendEmail: retryToken && resendEmail,
        heading: heading,
        subHeading: subHeading
      }),
      showCloseButton: false
    });
  };

  const handleSocialLogin = provider => event => {
    event.stopPropagation();
    const signInUrl = new URL(`${config.API_URL}/auth/${provider}`);
    signInUrl.searchParams.append('redirect', encodeURIComponent(window.location.origin));
    window.location.href = signInUrl.href;
  };

  const label = isSignUp ? labels.signup : labels.signin;
  return /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(DocumentTitle, {
    title: isSignUp ? 'Sign up' : 'Login'
  }), /*#__PURE__*/React.createElement(LogoLink, {
    href: "https://www.crystallize.com",
    rel: "noreferrer",
    "aria-label": "Go to Crystallize website"
  }, /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 213 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.689 47.66h6.823v2.4h-9.265V33.306h2.442V47.66zM171.559 47.66h6.824v2.4h-9.266V33.306h2.442V47.66zM181.989 33.306h2.442v16.728h-2.442V33.306zM198.694 33.329l-6.8 14.331h6.778v2.42h-10.636v-.023l6.733-14.378h-5.82v-2.373h9.745l-.023.023h.023zM204.719 47.592h7.44v2.4H202.3V33.329h9.7v2.35h-7.28v5.66h6.55v2.282h-6.55l-.001 3.971zM70.41 47.729c.9401.0077 1.8655-.2338 2.682-.7.8038-.4539 1.4891-1.0912 2-1.86l1.985 1.483c-.7543 1.0292-1.734 1.8724-2.864 2.465-1.1715.6143-2.4773.928-3.8.913-1.1072.0073-2.2036-.2183-3.218-.662-1.9826-.855-3.5576-2.4439-4.395-4.434-.4286-1.0299-.6492-2.1345-.6492-3.25s.2206-2.2201.6492-3.25c.8357-1.9917 2.4101-3.5826 4.393-4.439 1.0144-.4437 2.1108-.6693 3.218-.662 1.3226-.0148 2.6282.2985 3.8.912 1.1298.593 2.1094 1.4361 2.864 2.465l-1.985 1.483c-.511-.7685-1.1962-1.4055-2-1.859-.8165-.4662-1.7419-.7077-2.682-.7-.7678-.0054-1.5274.1582-2.225.479-.6829.3123-1.2988.7537-1.814 1.3-.5247.5587-.9426 1.2087-1.233 1.918-.6077 1.5077-.6077 3.1923 0 4.7.2904.709.7083 1.3587 1.233 1.917.5155.5459 1.1314.9873 1.814 1.3.698.3218 1.4584.486 2.227.481zM92.181 40.882c-.204.6674-.5246 1.2934-.947 1.849-.4246.5536-.9464 1.0253-1.54 1.392-.032.0317-.0711.0554-.114.069-.043.0129-.0822.0363-.114.068l2.944 5.8h-2.579l-2.579-5.044c-.182.031-.365.054-.547.069-.182.015-.381.023-.594.023h-2.989v4.952H80.68V33.283h5.431c1.2618-.0086 2.5016.3308 3.583.981 1.2059.7411 2.0925 1.9047 2.487 3.264.016.076.031.144.046.2.0183.0698.0414.1383.069.205v.115c.031.0801.0502.1643.057.25.008.092.019.183.034.274v.028c.015.0906.0227.1822.023.274v.639c-.0002.0918-.0079.1834-.023.274v.045c-.015.092-.026.18-.034.263-.0092.0892-.0283.1771-.057.262v.092c-.054.1397-.0926.2849-.115.433zm-5.773 2.077c.4789.005.9521-.1047 1.38-.32.4133-.2091.7818-.4968 1.085-.847.3079-.357.5545-.7625.73-1.2.3642-.8978.3642-1.9022 0-2.8-.1722-.4392-.4192-.8452-.73-1.2-.3058-.3442-.6739-.6275-1.085-.835-.4276-.2162-.9009-.3263-1.38-.321h-3.264v7.531l3.264-.008zM108.819 33.283v.023l-5.181 11.274v5.5H101.2v-5.5l-5.18-11.274h.022l-.022-.023h2.715l3.7 8.946 3.7-8.946h2.684zM121.6 41.7c.109.0774.209.1655.3.263.091.1.174.193.25.285.348.4372.625.9261.822 1.449.2.5289.301 1.0897.3 1.655.002.1068-.006.2136-.023.319-.038.8242-.307 1.621-.776 2.3-.418.6309-.981 1.1516-1.643 1.518-.685.3767-1.456.5693-2.237.559h-1.513c-.781.0103-1.552-.1823-2.237-.559-.661-.3639-1.224-.8814-1.643-1.509-.135-.2051-.257-.4186-.365-.639l2.122-1.643c.045.2853.142.56.286.81.142.2478.323.4712.536.662.442.3895 1.011.6031 1.6.6h.914c.596.0116 1.175-.2027 1.62-.6.446-.3844.738-.9172.822-1.5 0-.0612.003-.1223.011-.183.007-.0604.011-.1212.011-.182.003-.321-.059-.6393-.182-.936-.118-.2833-.288-.5423-.5-.764-.216-.2231-.471-.405-.752-.537-.286-.1355-.597-.213-.913-.228h-1.393c-.545-.0112-1.082-.1234-1.586-.331-.488-.2012-.94-.4827-1.335-.833-.212-.1506-.396-.3354-.547-.547-.348-.4375-.625-.9267-.822-1.45-.2-.5285-.301-1.089-.3-1.654v-.32c.063-.8231.338-1.6156.8-2.3.417-.6311.981-1.1517 1.644-1.517.684-.3769 1.455-.5695 2.236-.559h1.483c.785-.0094 1.559.1831 2.248.559.667.3633 1.235.8841 1.655 1.517.046.077.095.16.148.252.053.092.1.174.149.25l-2.078 1.621c-.131-.5391-.436-1.0202-.867-1.369-.427-.3606-.97-.5552-1.529-.548h-.916c-.3-.001-.598.0532-.879.16-.273.1009-.524.2518-.742.445-.215.1928-.396.4203-.536.673-.144.2544-.24.5325-.286.821-.015.0599-.022.1213-.022.183v.182c-.003.3211.059.6395.182.936.118.2838.287.5431.5.765.217.2227.472.4043.753.536.286.1361.597.2136.913.228h1.393c.545.0121 1.082.1243 1.586.331.489.2004.941.4806 1.338.829zM126.871 33.306h10.68v2.351h-4.13v14.354H131V35.657h-4.13l.001-2.351zM138.993 50.011l6.823-16.728 6.824 16.728h-2.488l-.5-1.323h-7.646l-.525 1.323h-2.488zm3.834-3.469h5.979l-2.99-7.668-2.989 7.668z",
    fill: "#777B82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.239 31.318L27.865 71.476l-13.393-8.544L24.847 0l15.136 24.585-1.744 6.733z",
    fill: "#A4D7DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.543 32.532L5.969 57.5l-2.012-1.281L0 27.181l9.543 5.351z",
    fill: "#D0E9EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.877 15.927l-7.619 46.227-6.06199-3.869L14.633 6.33099l6.244 9.59601z",
    fill: "#BBE0E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.171 29.514l-8.584 33.083-5.687 4.708-4.533 3.661 9.691-37.515 9.113-3.937z",
    fill: "#8ECED3"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h212.159v71.476H0z"
  }))))), /*#__PURE__*/React.createElement(Inner, null, /*#__PURE__*/React.createElement(Title, null, label.title), isSignUp ? /*#__PURE__*/React.createElement(Headline, null, "Batteries included. Crystallize is fully featured on all tiers. Free forever.", ' ', /*#__PURE__*/React.createElement("strong", null, "No credit card"), " required for the free tier") : /*#__PURE__*/React.createElement(Headline, null, "Select a login option to reconnect with your favorite tenant"), /*#__PURE__*/React.createElement(Form, {
    onSubmit: handleSubmit
  }, /*#__PURE__*/React.createElement(Label, {
    htmlFor: "sign-in-with-email"
  }, /*#__PURE__*/React.createElement("input", {
    type: "email",
    id: "sign-with-email",
    required: true,
    placeholder: "name@domain.com"
  }), /*#__PURE__*/React.createElement("button", {
    disabled: submitting
  }, label.magicLinkButton, submitting && /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(LoadingSpinner, null))))), /*#__PURE__*/React.createElement(Divider, null, "or", /*#__PURE__*/React.createElement("span", {
    className: "line"
  })), /*#__PURE__*/React.createElement(List, null, SOCIAL_LOGINS.map(({
    name,
    image
  }) => /*#__PURE__*/React.createElement(ListItem, {
    key: name
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: handleSocialLogin(name)
  }, /*#__PURE__*/React.createElement("img", {
    src: image,
    alt: `${name} logo`,
    width: 48,
    height: 48
  }), isSignUp ? 'Sign up' : 'Login', " with ", name)))), /*#__PURE__*/React.createElement("p", {
    className: "italic"
  }, "These social logins are strictly for identification purposes. We will never ask to publish anything on your behalf."), /*#__PURE__*/React.createElement("p", null, isSignUp ? `Already` : `Don't`, " have an account?", ' ', /*#__PURE__*/React.createElement(Link, {
    to: isSignUp ? '/signin' : '/signup'
  }, isSignUp ? `Login` : `Sign up`, " to Crystallize"))));
}

export default SignInSignUp;